<!--
 * @Description: 异动反馈情况
 * @Author: cxh
 * @Date: 2023-05-16 17:14:17
 * @LastEditTime: 2023-06-20 16:20:08
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" @fetch="fetch" tableId="ofbuClientsFollowChangeFeedback">
    <template #bodyCell="{ column, text }">
      <template v-if="column.dataIndex === 'process'">
        <EditorTableText :value="text" />
      </template>
    </template>
  </cos-table>
</template>
<script lang="ts">
import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/overseasSales/analysis'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { listByParamCodes } from '@/api/common'
import { alarmTypeEnum, alarmLevelEnum, alarmProcessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
export default { name: 'DcCosOFbuFollowChangeFeedback' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const paramCodeData = ref<any>({
  ofbu_change_description: [] // 异动说明
})
const props = defineProps({
  cosId: {
    type: String,
    require: true
  }
})
const columns = computed(() => [
  {
    title: t('exception.exceptionTime'),
    dataIndex: 'alarmDate'
  },
  {
    title: t('custom.arkCode'),
    dataIndex: 'arkCode'
  },
  {
    title: t('exception.exceptionType'),
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: t('exception.exceptionLevel'),
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: t('exception.exceptionReason'),
    dataIndex: 'alarmInfo'
  },
  {
    title: t('exception.exceptionDes'),
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.ofbu_change_description
  },
  {
    title: t('follow.processDetail'),
    dataIndex: 'process'
  },
  {
    title: t('exception.followUpTime'),
    dataIndex: 'processTime'
  },
  {
    title: t('exception.followUpDes'),
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  if (!props.cosId) {
    callBack({
      items: [],
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0
    })
    return
  }
  followAlarmGet({
    ...params,
    cosId: props.cosId
  }).then((res) => {
    callBack(res)
  })
}
</script>
